<script setup lang="ts">
import type { Study } from '@pocketprep/types'
import UIKit from '@pocketprep/ui-kit'

export type TBundleExam = Study.Class.ExamMetadataJSON & {
    bundle: Study.Class.BundleJSON
}

const { BundleIcon } = UIKit

const props = defineProps<{
    exam: TBundleExam
}>()
</script>

<template>
    <div
        class="bundle-exam"
        tabindex="0"
    >
        <div class="bundle-exam__name-short">
            {{ props.exam.nativeAppName }}
        </div>
        <div class="bundle-exam__name-long">
            {{ props.exam.descriptiveName }}
        </div>
        <div class="bundle-exam__detail-counts">
            <span class="bundle-exam__question-count">
                {{ props.exam.itemCount - props.exam.archivedCount }}
            </span> Questions,
            <span class="bundle-exam__subject-count">
                {{ Object.keys(props.exam.knowledgeAreas).length }}
            </span> Subjects
        </div>
        <span class="bundle-exam__label">
            <BundleIcon
                class="bundle-exam__label-icon"
                :bundle-id="props.exam.bundle.objectId"
            />
            {{ props.exam.bundle.name }}
        </span>
    </div>
</template>

<style lang="scss" scoped>


.bundle-exam {
    position: relative;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 rgba($brand-black, 0.15), 0 1px 2px 0 rgba($brand-black, 0.06);
    box-sizing: border-box;
    width: 305px;
    height: 120px;
    padding: 11px 13px;
    margin: 8px 8px 5px;
    outline: none;
    cursor: pointer;

    &:hover,
    &:focus {
        &::before {
            content: '';
            position: absolute;
            border-radius: 4px;
            border: 2px solid $pewter;
            top: -2px;
            bottom: -2px;
            left: -2px;
            right: -2px;
        }
    }

    &__name-short {
        font-weight: 600;
        font-size: 15px;
        letter-spacing: 0.47px;
        line-height: 18px;
        margin-bottom: 3px;
    }

    &__name-long {
        color: $slate-03;
        font-weight: 400;
        font-size: 13px;
        line-height: 17.76px;
        margin-bottom: 3px;
    }

    &__detail-counts {
        font-size: 13px;
        line-height: 17.76px;
        color: $slate-03;
        font-weight: 400;
    }

    &__question-count,
    &__subject-count {
        font-weight: 500;
    }

    &__label {
        position: absolute;
        bottom: 9px;
        display: flex;
        align-items: center;
        font-size: 12px;
        line-height: 14px;
    }

    &__label-icon {
        width: 20px;
        height: 20px;
        margin-right: 7px;
    }
}
</style>
